import { Component, OnInit, inject } from '@angular/core';
import { Theme, UiInfo } from '../../../backend/model/theme.model';
import { ThemeHandlerService } from '../../../idp/service/theme-handler.service';
import { IDHeaderIneraAdminComponent } from '@inera/ids-angular/components/header-inera-admin';
import { IDHeader1177Component } from '@inera/ids-angular/components/header-1177';
import { IDHeader1177ProComponent } from '@inera/ids-angular/components/header-1177-pro';
import { IDHeader1177AdminComponent } from '@inera/ids-angular/components/header-1177-admin';

@Component({
  selector: 'idp-header',
  imports: [IDHeaderIneraAdminComponent, IDHeader1177Component, IDHeader1177ProComponent, IDHeader1177AdminComponent],
  templateUrl: './idp-header.component.html',
  styleUrls: ['./idp-header.component.scss']
})
export class IdpHeaderComponent implements OnInit {
  private themeHandler = inject(ThemeHandlerService);

  public theme: Theme;
  public mduiInfo: UiInfo;

  ngOnInit() {
    this.themeHandler.getTheme().subscribe(theme => {
      this.theme = theme?.value?.value;
      this.mduiInfo = theme?.uiInfo;
    });
  }
}
